import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { RECOVER, RESET } from './types';

export const recoverPassword = createTaskAction(RECOVER);
export const resetPassword = createTaskAction(RESET);
